import customTheme from "../../../theme";
import { marginWidths, columnsWidth, columnsCount, gutterWidths } from "../../constants/Login/index";

/** Estilos provisionales en login */
const loginStyles = {
	root: {
		height: "100vh",		
		overflow: "auto",
		backgroundColor: "#0b5c96",
		[customTheme.breakpoints.down('md')]: {
			overflow: 'unset'
		}
	},
	mainLogin: {
		height: "100%",
	}, 
	description: {
		marginTop: 'auto',
    	marginBottom: customTheme.spacing(10),
		[customTheme.breakpoints.only('md')]: {
			paddingLeft: marginWidths.md,
			width: `calc((((100% - ${columnsWidth.md}px) * 6) / ${columnsCount.md}) + ${gutterWidths.md * 5 + marginWidths.md * 1}px)`,
		},
		[customTheme.breakpoints.only('lg')]: {
			paddingLeft: marginWidths.lg,
			width: `calc((((100% - ${columnsWidth.lg}px) * 6) / ${columnsCount.lg}) + ${gutterWidths.lg * 5 + marginWidths.lg * 1}px)`
		},
		[customTheme.breakpoints.only('xl')]: {
			paddingLeft: marginWidths.xl,
			width: `calc((((100% - ${columnsWidth.xl}px) * 6) / ${columnsCount.xl}) + ${gutterWidths.xl * 5 + marginWidths.xl * 1}px)`
		},
	},
	imageContainer: {
		marginTop: 'auto',
		marginBottom: customTheme.spacing(13),
		[customTheme.breakpoints.only("xs")]: {
			display: "none",
		},
		[customTheme.breakpoints.only('md')]: {
			paddingLeft: marginWidths.md,

			width: `calc((((100% - ${columnsWidth.md}px) * 6) / ${columnsCount.md}) + ${gutterWidths.md * 5 + marginWidths.md * 1}px)`,
		},
		[customTheme.breakpoints.only('lg')]: {
			paddingLeft: marginWidths.lg,
			width: `calc((((100% - ${columnsWidth.lg}px) * 6) / ${columnsCount.lg}) + ${gutterWidths.lg * 5 + marginWidths.lg * 1}px)`
		},
		[customTheme.breakpoints.only('xl')]: {
			paddingLeft: marginWidths.xl,
			width: `calc((((100% - ${columnsWidth.xl}px) * 6) / ${columnsCount.xl}) + ${gutterWidths.xl * 5 + marginWidths.xl * 1}px)`
		},
	},
	image: {
		height: 160
	},
	titleMonitor: {
		fontWeight: 500,
		letterSpacing: '0.15px',
		fontSize: 20,
		lineHeight: '30px',
		color: "white",
	},
	title: {
		[customTheme.breakpoints.only('xs')]: {
			marginLeft: customTheme.spacing(1),
			marginRight: customTheme.spacing(1)
		},
		[customTheme.breakpoints.only('sm')]: {
			marginRight: customTheme.spacing(4)
		},
		[customTheme.breakpoints.only('md')]: {
			marginRight: customTheme.spacing(6)
		},
		fontSize: 20,
		fontWeight: 500,
		lineHeight: 1.5,
		letterSpacing: "normal",
		marginBottom: customTheme.spacing(1),
		display: 'inline',
	},
	form: {
		//maxWidth: "562px", // Fix IE 11 issue.
	},
	logoMO: {
		height: '48px',
   		width: '124px',
	},
	logoMoContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	paperContainer: {
		border: "1px solid #ccc",
		[customTheme.breakpoints.only('xs')]: {
			paddingLeft: marginWidths.xs,
			paddingRight: marginWidths.xs,
			width: "100%",
			borderRadius: '0px !important',
			height: "100%"
		},
		[customTheme.breakpoints.only('sm')]: {
			paddingLeft: marginWidths.sm,
			paddingRight: marginWidths.sm,
			width: "100%",
			borderRadius: '0px !important',
			height: "100%",
		},
		[customTheme.breakpoints.only('md')]: {
			marginTop: 'auto',
			marginBottom: customTheme.spacing(2),
			width: `calc((((100% - ${columnsWidth.md}px) *6) / ${columnsCount.md}) + ${gutterWidths.md * 5 + marginWidths.md * 0}px)`
		},
		[customTheme.breakpoints.only('lg')]: {
			marginTop: 'auto',
			marginBottom: customTheme.spacing(2),
			width: `calc((((100% - ${columnsWidth.lg}px) * 4) / ${columnsCount.lg}) + ${gutterWidths.lg * 5 + marginWidths.lg * 0}px)`
		},
		[customTheme.breakpoints.only('xl')]: {
			marginTop: 'auto',
			marginBottom: customTheme.spacing(2),
			width: `calc((((100% - ${columnsWidth.xl}px) * 4) / ${columnsCount.xl}) + ${gutterWidths.xl * 5 + marginWidths.xl * 0}px)`
		}
	},
	footerGrid: {
		marginTop: customTheme.spacing(1),
	},
	footerTitle: {
		fontWeight: 500,
	},
	footerSubtitle: {
		flexGrow: 1
	},
	footerLinks: {
		cursor: 'pointer'
	},
	forgotPassword: {
		paddingBottom: customTheme.spacing(6),
	},
	cambiarDeSistema: {
		flexGrow: 1,
		textAlign: "center",
		marginTop: customTheme.spacing(4),
		fontSize: 16,
	},
	subtitle: {
		flexGrow: 1,
		textAlign: "center",
		margin: "48px 0px 0px !important"
	},
	buttonSpace: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		paddingTop: 2,
		marginTop: customTheme.spacing(3),
		marginBottom: customTheme.spacing(5)
	},
	sendRecoveryContainer: {
		marginTop: customTheme.spacing(3),
		marginBottom: customTheme.spacing(3),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
};

export default loginStyles;
